import { FC, ReactElement } from 'react'

import { useNotifications, SimpleModal } from '@sequencehq/core-components'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'

import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'
import { useQuoteApproval } from 'Cube/domain'

export const CancelApprovalModal: FC<{
  trigger: ReactElement
  onSubmit?: () => void
}> = ({ trigger, onSubmit }) => {
  const { displayNotification } = useNotifications()
  const ctx = useCubeContext()

  const { runningExecutionId } = useQuoteApproval()

  return (
    <SimpleModal
      variant="dialog"
      trigger={trigger}
      onSubmit={async () => {
        try {
          if (!runningExecutionId) {
            throw new Error('runningExecutionId is undefined')
          }

          const res =
            await dashboardv99990101Client.postCancelAutomationExecution({
              id: runningExecutionId
            })

          if (res.error) {
            throw new Error('Unable to cancel automation execution')
          }

          await ctx.mutators.external.in.core()

          onSubmit?.()

          displayNotification('Approval request successfully cancelled', {
            type: 'success'
          })

          return true
        } catch {
          displayNotification('Failed to cancel approval request', {
            type: 'error'
          })
          return false
        }
      }}
      title="Are you sure you want to cancel this approval request?"
      submitButtonText="Cancel review"
    >
      This will cancel any pending approval requests for this quote.
    </SimpleModal>
  )
}
